import AuthModel from './auth-model';
import AuthView from './auth-view';

export default class AuthPresenter {
  constructor(model, view, appInterface) {
    this.model = model || new AuthModel();
    this.view = view || new AuthView();
    this.appInterface = appInterface || {};
  }

  async init() {
    const isAuthenticated = this.model.loadUserState();
    
    if (isAuthenticated) {
      this.appInterface.navigateTo('home');
      return;
    }
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.view.setupFormEventListeners(
      (formData) => this.handleLogin(formData),
      (formData) => this.handleRegister(formData),
      (button) => this.togglePassword(button)
    );

    this.view.setupNavigationEventListeners(
      () => this.showRegisterForm(),
      () => this.showLoginForm(),
      () => this.continueAsGuest()
    );
  }

  showRegisterForm() {
    this.view.showRegisterForm();
    this.model.setCurrentForm('register');
    this.appInterface.reinitTooltips();
  }

  showLoginForm() {
    this.view.showLoginForm();
    this.model.setCurrentForm('login');
    this.appInterface.reinitTooltips();
  }

  continueAsGuest() {
    this.appInterface.navigateTo('home');
    this.appInterface.showToast('Melanjutkan sebagai tamu', 'success');
  }

  async handleLogin(formData) {
    const { email, password } = formData;
    
    const validation = this.model.validateLoginForm(email, password);
    if (!validation.valid) {
      this.appInterface.showToast(validation.message, 'error');
      return;
    }
    
    this.view.setLoginButtonLoading(true);
    
    try {
      const result = await this.model.loginUser(email, password);
      
      if (result.success) {
        this.appInterface.setAuthState(true, result.user, result.token);
        if (this.appInterface.refreshHomePresenter) {
          this.appInterface.refreshHomePresenter();
        }
        this.appInterface.navigateTo('home');
        this.appInterface.showToast(`Selamat datang kembali, ${result.user.name}!`, 'success');
      }
    } catch (error) {
      this.appInterface.showToast(error.message || 'Gagal masuk. Silakan coba lagi.', 'error');
    } finally {
      this.view.setLoginButtonLoading(false);
    }
  }

  async handleRegister(formData) {
    const { name, email, password } = formData;
    
    const validation = this.model.validateRegisterForm(name, email, password);
    if (!validation.valid) {
      this.appInterface.showToast(validation.message, 'error');
      return;
    }
    
    this.view.setRegisterButtonLoading(true);
    
    try {
      const result = await this.model.registerUser(name, email, password);
      
      if (result.success) {
        this.appInterface.showToast('Registrasi berhasil! Silakan masuk.', 'success');
        this.view.clearRegisterForm();
        this.view.prefillLoginEmail(email);
        this.showLoginForm();
      }
    } catch (error) {
      this.appInterface.showToast(error.message || 'Gagal mendaftar. Silakan coba lagi.', 'error');
    } finally {
      this.view.setRegisterButtonLoading(false);
    }
  }

  togglePassword(button) {
    this.view.togglePasswordVisibility(button);
    this.appInterface.reinitTooltips();
  }

  cleanup() {
    this.view.cleanup();
  }
}